import { useState, useEffect } from "react";
import Logout from '../components/Logout';
import NavigationButton from './NavigationButton';

import { withRouter } from '../utils/withRouter.js';

import { whoami } from "../services/APIClient";
import { isTeacher } from "../utils/auth";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './HeadingBanner.scss';

function HeadingBanner(props) {
    const colour = useState('grey');

    // ✅ Check if current user is a teacher
    const teacherMode = isTeacher();

    // ✅ Handler to return to TD
    // ✅ Handler to return to TD admin dashboard
    const handleReturnToTD = () => {
        const tdAdminUrl = process.env.REACT_APP_TD_ADMIN_DASHBOARD || `${process.env.REACT_APP_TD_URL}/admindashboard`;
        console.log('🔙 Returning to TD Admin Dashboard:', tdAdminUrl);

        // Clean up CSD-specific localStorage
        localStorage.removeItem('source_app');
        localStorage.removeItem('teacher_school_id');

        window.location.href = tdAdminUrl;
    };

    // ✅ Different cloud content for teachers vs staff
    const teacherCloudContent = <div>
        <div className="leftPosition">
            <button
                onClick={handleReturnToTD}
                className="return-to-td-btn"
                title="Return to Teacher Dashboard"
            >
                ← TD
            </button>
        </div>
        <div className="centrePosition"><NavigationButton img='/assets/imgs/avatar.svg' alt='profile' route='/profile' isLoggedIn={props.isLoggedIn} teacherid={props.teacherid} /></div>
        <div className="rightPosition"><Logout isLoggedIn={props.isLoggedIn} /></div>
    </div>;

    const staffCloudContent = <div>
        <div className="leftPosition"><NavigationButton img='/assets/imgs/home_icon.svg' alt='home' route='/masterdashboard' isLoggedIn={props.isLoggedIn} teacherid={props.teacherid} /></div>
        <div className="centrePosition"><NavigationButton img='/assets/imgs/avatar.svg' alt='profile' route='/profile' isLoggedIn={props.isLoggedIn} teacherid={props.teacherid} /></div>
        <div className="rightPosition"><Logout isLoggedIn={props.isLoggedIn} /></div>
    </div>;

    const cloudContent = teacherMode ? teacherCloudContent : staffCloudContent;

    // ✅ Dynamic heading text based on role
    const headingText = teacherMode ? 'Teacher Admin Portal' : 'Customer Service Dashboard';

    // ✅ Dynamic color based on role
    const headerColour = teacherMode ? 'teacher-blue' : (props.colour || 'blue');

    return (
        <div className="headerContainer">
            <ColourHeader
                colour={headerColour}
                text={props.headingText || headingText}
                isLoggedIn={props.isLoggedIn}
            />
            <MainBanner name={props.name} cloud={props.cloud} control={cloudContent} />
        </div>
    );
}


/**
 * Simple banner across the top of the screen.
 * Colour can be customised depending on the parameterisation to one of the predefined values
 * 
 * @param {} colour
 * @param {} text
 * @param {} isloggedIn
 * @returns 
 */
function ColourHeader({ colour = 'blue', text = 'Customer Service Dashboard' }) {
    return (
        <Row className={`header ${colour}`}>
            <Col sm={2}></Col>
            <Col className="d-flex justify-content-center"><h1>{text}</h1></Col>
            <Col sm={2}></Col>
        </Row>
    );
}

function MainBanner(props) {

    let name = props.name;
    let cloud = props.cloud;
    let control = props.control;

    return (
        <Row className="subheader">
            <Col className="d-flex">
                <div className="logo col-2"></div>
                <h2 className="subheading-text col-7">{name}</h2>
                <div className={`${cloud ? 'cloud' : 'circle'}`}>
                    {control}
                </div>
            </Col>
        </Row>
    );
}

export default withRouter(HeadingBanner);